import Svg from '../../../../../Svg'

type Props = {
  items: { labels: string[]; src: string }[]
}

export const WebCareIcons = (props: Props) => (
  <div
    className="bg-white relative rounded-2xl grid text-center px-1 py-3"
    style={{ gridTemplateColumns: `repeat(${props.items.length}, 1fr)` }}
  >
    {props.items.map((item) => {
      const label = item.labels.join('')
      return (
        <div key={label} className="flex flex-col items-center">
          <div className="w-10 sm:w-8 ">
            <Svg alt={label} className="mb-2" height={50} src={item.src} width={50} />
          </div>

          <div className="text-xs italic">
            {item.labels.map((label) => (
              <span key={label} className="block">
                {label}
              </span>
            ))}
          </div>
        </div>
      )
    })}
  </div>
)
